module.exports = __webpack_public_path__ + "static/img/kjdy05.4d74675.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/jingmai/kjdy05.png
// module id = 130
// module chunks = 0